// A (possibly faster) way to get the current timestamp as an integer.
export default Date.now || function() {
  return new Date().getTime();
};



//////////////////
// WEBPACK FOOTER
// ./~/backbone/~/underscore/modules/now.js
// module id = 187
// module chunks = 8